export default {
    locale: 'zh-CN',
    Calendar: {
        today: '今天',
        view: {
            month: '月视图',
            year: '年视图',
        },
        month: {
            long: {
                January: '一月',
                February: '二月',
                March: '三月',
                April: '四月',
                May: '五月',
                June: '六月',
                July: '七月',
                August: '八月',
                September: '九月',
                October: '十月',
                November: '十一月',
                December: '十二月',
            },
            short: {
                January: '一月',
                February: '二月',
                March: '三月',
                April: '四月',
                May: '五月',
                June: '六月',
                July: '七月',
                August: '八月',
                September: '九月',
                October: '十月',
                November: '十一月',
                December: '十二月',
            },
        },
        week: {
            long: {
                self: '周',
                monday: '周一',
                tuesday: '周二',
                wednesday: '周三',
                thursday: '周四',
                friday: '周五',
                saturday: '周六',
                sunday: '周日',
            },
            short: {
                self: '周',
                monday: '一',
                tuesday: '二',
                wednesday: '三',
                thursday: '四',
                friday: '五',
                saturday: '六',
                sunday: '日',
            },
        },
    },
    DatePicker: {
        week: {
            self: '周',
            monday: '一',
            tuesday: '二',
            wednesday: '三',
            thursday: '四',
            friday: '五',
            saturday: '六',
            sunday: '日',
        },
        month: {
            January: '一月',
            February: '二月',
            March: '三月',
            April: '四月',
            May: '五月',
            June: '六月',
            July: '七月',
            August: '八月',
            September: '九月',
            October: '十月',
            November: '十一月',
            December: '十二月',
        },
        placeholder: '请输入日期',
        placeholders: ['开始日期', '结束日期'],
        selectTime: '选择时间',
        today: '今天',
        now: '此刻',
        ok: '确定',
    },
    Drawer: {
        okText: '确定',
        cancelText: '取消',
    },
    Empty: {
        noData: '暂无数据',
    },
    Modal: {
        okText: '确定',
        cancelText: '取消',
    },
    Pagination: {
        goto: '前往',
        page: '页',
        countPerPage: '条/页',
        total: '共 {0} 条',
    },
    Popconfirm: {
        okText: '确定',
        cancelText: '取消',
    },
    Table: {
        okText: '确定',
        resetText: '重置',
    },
    TimePicker: {
        startTime: '开始时间',
        endTime: '结束时间',
        placeholders: ['开始时间', '结束时间'],
    },
    Progress: {
        success: '完成',
        error: '失败',
    },
    Upload: {
        cancel: '取消',
        delete: '删除',
        reupload: '重新上传',
        upload: '点击上传',
        preview: '预览',
        drag: '点击或拖拽文件到此处上传',
        dragHover: '释放文件并开始上传',
    },
};
